'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');
var SubscriptionModalLayout = require('modules/settings/views/layout/subscription/modal');

var templateDisplay = require('modules/settings/templates/partials/subscription/billing-address-display.hbs');
var templateEdit = require('modules/settings/templates/partials/subscription/billing-address-edit.hbs');

var SubscriptionBillingAddressView = ItemView.extend({
    getTemplate: function() {
        return this.getOption('mode') === 'edit' ? templateEdit : templateDisplay;
    },

    className: function() {
        return this.getOption('mode') === 'edit' ? 'subscription-billing-address-edit' : 'subscription-billing-address-display';
    },

    ui: {
        form: 'form',
        editButton: '[data-action="edit"]',
        smartInputs: '.input-label-group input, .input-label-group textarea',
        fields: 'input, select',
        saveButton: '[type="submit"]',
    },

    events: {
        'submit @ui.form': 'onSubmit',
        'click @ui.editButton': 'openEditModal',
        'keyup @ui.smartInputs': 'checkInputWithLabel',
        'keydown @ui.smartInputs': 'checkInputWithLabel',
        'change @ui.fields': 'removeFormErrors',
    },

    isSetup: false,

    mode: 'display',

    viewData: {
        countryCollection: function() {
            return App.radio().request('countries:collection');
        },
    },

    onRender: function() {
        ItemView.prototype.onRender.apply(this, arguments);

        this.ui.smartInputs.trigger('keydown');
    },

    onShow: function() {
        if (this.getOption('mode') === 'edit') {
            this.triggerMethod('readyToSave');
        }
    },

    onSubmit: function(event) {
        if (event) {
            event.preventDefault();
        }

        this.updateFormErrors();

        if (!this.isValid()) { return; }

        // Show loading
        this.triggerMethod('saving');

        this.model.save(this.getData(), {
            patch: true,
            wait: true,
            success: function(model) {
                this.triggerMethod('saved', this.getData());
            }.bind(this),
            error: function(model, response) {
                this.triggerMethod('save:error', response);
            }.bind(this),
        });
    },

    onSaving: function() {
        if (this.getOption('isSetup') !== true) {
            this.ui.saveButton.prop('disabled', true).addClass('is-loading');
        }
    },

    validate: function() {
        var data = this.getData();
        var validationErrors = {};

        if (data.vatId !== '') {
            if (data.billingAddress.fullname === '' && data.billingAddress.company === '') {
                validationErrors['billingAddress[fullname]'] = App.t('subscription::setup:billing-address:error:fullname');
                validationErrors['billingAddress[company]'] = App.t('subscription::setup:billing-address:error:company');
            }

            if (data.billingAddress.country === '') {
                validationErrors['billingAddress[country]'] = App.t('subscription::setup:billing-address:error:country');
            }
        }

        return validationErrors;

        // this.triggerMethod('readyToSave', {nextButtonLabel: 'Proceed to checkout'});
    },

    isValid: function() {
        var validationErrors = this.validate();

        return _.isEmpty(validationErrors);
    },

    getData: function() {
        return {
            setupStep: this.getOption('isSetup') ? this.model.get('setupStep') + 1 : this.model.get('setupStep'),
            vatId: this.$('[name="subscription-vatId"]').val(),
            billingAddress: {
                fullname: this.$('[name="subscription-billingAddress[fullname]"]').val(),
                company: this.$('[name="subscription-billingAddress[company]"]').val(),
                street: this.$('[name="subscription-billingAddress[street]"]').val(),
                zip: this.$('[name="subscription-billingAddress[zip]"]').val(),
                city: this.$('[name="subscription-billingAddress[city]"]').val(),
                country: this.$('[name="subscription-billingAddress[country]"]').val(),
            },
        };
    },

    openEditModal: function(event) {
        App.addModal(new SubscriptionModalLayout({
            title: App.t('subscription::setup:billing-address:title'),
            bodyView: new SubscriptionBillingAddressView({
                mode: 'edit',
                model: this.model,
            }),
        }), {
            additionalClassName: 'modal-subscription ' + (this.getOption('isSetup') ? 'modal-subscription-setup' : ''),
        });
    },

    showError: function(errorObject) {
        this.ui.form.find('fieldset.error').removeClass('error');
        this.ui.form.find('p.error').remove();

        if (_.isObject(errorObject)){
            _.each(errorObject, function(message, field) {
                var field = this.ui.form.find('[name="subscription-' + field + '"]');
                var fieldset = field.closest('fieldset');

                fieldset.addClass('error');
                fieldset.prepend($('<p>').addClass('error').text(message));
            }.bind(this))
        }
    },

    updateFormErrors: function() {
        var validationErrors = this.validate();
        this.showError(validationErrors);
    },

    removeFormErrors: function() {
        this.showError();
    },

    /**
     * Event for checking the label input group
     * @param {object} event The event object
     * @return {void}
     */
    checkInputWithLabel: function(event) {
        var input = $(event.currentTarget);
        input.closest('.input-label-group').toggleClass('has-value', input.val().length > 0);
    },

    onSaveError: function(response) {
        var errorObject = response.responseJSON && response.responseJSON.error;
        if (errorObject) {
            this.showError(errorObject);
        }

        if (this.getOption('isSetup') !== true) {
            this.ui.saveButton.prop('disabled', false).removeClass('is-loading');
        }
    },
});

module.exports = SubscriptionBillingAddressView;